import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon as FAIcon } from '@fortawesome/react-fontawesome';
import { faUnlink } from '@fortawesome/free-solid-svg-icons';

const Card = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  grid-gap: 0.5rem;
  padding: 1rem 0.5rem;
  width: 100%;
  box-shadow: var(--elevation-default);
  border-radius: 5px;
`;

const ColoredIcon = styled.div`
  svg {
    height: 100%;
    width: 100%;
    cursor: pointer;
    color: var(--color-primary);
  }
`;

const FlatCard = ({ card, unassignStudent }) => {
  const { first_name, last_name } = card.attributes;
  return (
    <Card>
      <p>{`${first_name} ${last_name}`}</p>
      <ColoredIcon>
        <FAIcon icon={faUnlink} onClick={unassignStudent} />
      </ColoredIcon>
    </Card>
  );
};

export default FlatCard;



// WEBPACK FOOTER //
// ./src/components/Sidebar/FlatCard.jsx